// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DL2-","colMin":"styles_colMin__2xwtU"};